import React from 'react';
import { Task, TaskStatus } from '../../types/Task';
import { DateTime } from 'luxon';
import { Chip, ChipProps } from '@mui/material';
import { taskBaseColor } from '../../utility/task';
import TaskStatusPill from './TaskStatusPill';
import _ from 'lodash';

interface ITaskStatusPillProps extends ChipProps {
  task: Task;
}

export default function TaskDuePill({ task, ...rest }: ITaskStatusPillProps) {
  if (!task.status) return null;

  if (task.status == TaskStatus.COMPLETED) {
    return <TaskStatusPill status={task.status} />;
  }

  const today = DateTime.now().startOf('day');
  const dueDate = task.due_date ? DateTime.fromISO(task.due_date).startOf('day') : null;
  const daysDifference = dueDate && today.diff(dueDate, 'days').days;
  if (_.isNil(daysDifference)) {
    return (
      <Chip
        {...rest}
        label="Not Due"
        sx={{
          borderRadius: '6px',
          backgroundColor: 'var(--table-header-bg)',
          border: `1px solid var(--border-color)`,
          height: '28px',
        }}
      />
    );
  }

  let baseColor = taskBaseColor(TaskStatus.IN_PROGRESS);
  let text = 'Due today';
  if (daysDifference > 0) {
    baseColor = '#F95454';
    text = `Overdue ${daysDifference} day${daysDifference > 1 ? 's' : ''}`;
  } else if (daysDifference < 0) {
    baseColor = taskBaseColor(TaskStatus.READY);
    text = `Due in ${Math.abs(daysDifference)} day${Math.abs(daysDifference) > 1 ? 's' : ''}`;
  }

  const chipProps: ChipProps = _.merge(rest, {
    label: text,
    sx: {
      borderRadius: '6px',
      background: `${baseColor}30`,
      border: `1px solid ${baseColor}80`,
      height: '28px',
    },
  });

  return <Chip {...chipProps} />;
}
